import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TemplateTag } from '@debbie/common/dist/templates/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { Button, Modal, Select } from '../../index.js';
const VersionsModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [selectedTag, setSelectedTag] = useState(undefined);
    const addTag = async (templateId, tag) => {
        await templatesAPI.patch(templateId, { tag: { tag: tag } });
    };
    return (React.createElement(Modal, { header: lang.templates.addTag, onToggle: props.toggleTagModal },
        React.createElement(Select, { value: selectedTag, onChange: (e) => setSelectedTag(e.target.value) },
            React.createElement("option", { value: undefined },
                "- ",
                lang.templates.selectTag,
                " -"),
            Object.values(TemplateTag).map((tag) => (React.createElement("option", { key: tag, value: tag }, lang.templateTags[tag])))),
        React.createElement(Button, { onClick: async () => {
                if (selectedTag) {
                    await addTag(props.templateId, selectedTag);
                }
                props.toggleTagModal();
                props.loadTemplate();
            }, disabled: !selectedTag }, lang.templates.addTag)));
};
export default VersionsModal;
//# sourceMappingURL=AddTagModal.js.map